import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const promotionStatsQuery = graphql(`
  query PromotionStats($days: Int!) {
    promotionStats(days: $days) {
      spend_amount
      impressions
      clicks
      conversions
      days {
        date
        spend_amount
        impressions
        clicks
        conversions
      }
    }
  }
`);

export type PromotionStats = ResultOf<
  typeof promotionStatsQuery
>["promotionStats"];

export type PromotionStatsDay = PromotionStats["days"][number];
